module.exports = __webpack_public_path__ + "sg.svg?67651fbffb8cbc4a9ebc0aa8b88196a3";